<template>
    <woot-modal :show.sync="show" :on-close="onClose">
      <div class="column content-box">
        <woot-modal-header
          :header-title="$t('CAMPAIGN_FLOW.CONFIG.TITLE')"
          :header-content="$t('CAMPAIGN_FLOW.CONFIG.DESC')"
        />
        <form class="row" @submit.prevent="handleSubmit">
          <div class="medium-12 columns">
            <label>
              {{ $t('CAMPAIGN_FLOW.CONFIG.FORM.LIST.LABEL') }}
              <select v-model="selectedListId" id="selectItem">
                <option value="" disabled>
                  {{ $t('CAMPAIGN_FLOW.CONFIG.FORM.LIST.PLACEHOLDER') }}
                </option>
                <option v-for="item in list" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </label>

            <label>
              {{ $t('CAMPAIGN_FLOW.CONFIG.FORM.TRIGGER.LABEL') }}
              <select v-model="selectedTriggerId">
                <option value="" disabled>
                  {{ $t('CAMPAIGN_FLOW.CONFIG.FORM.TRIGGER.PLACEHOLDER') }}
                </option>
                <option v-for="item in triggers" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </label>

            <delay-input
              v-if="selectedTriggerId === 'after_creation'"
              v-model="delay"
              :label="$t('CAMPAIGN_FLOW.CONFIG.FORM.DELAY.LABEL')"
              :placeholder="$t('CAMPAIGN_FLOW.CONFIG.FORM.DELAY.PLACEHOLDER')"
              :unit-labels="{
                minutes: $t('CAMPAIGN_FLOW.CONFIG.FORM.DELAY.UNITS.MINUTES'),
                hours: $t('CAMPAIGN_FLOW.CONFIG.FORM.DELAY.UNITS.HOURS'),
                days: $t('CAMPAIGN_FLOW.CONFIG.FORM.DELAY.UNITS.DAYS'),
              }"
            />

            <label v-if="selectedTriggerId === 'scheduling'">
              {{ $t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.LABEL') }}
              <woot-date-time-picker
                :value="scheduledAt"
                :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
                :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
                @change="onChange"
              />
            </label>

            <div class="modal-footer">
              <woot-button class="bg-primary">
                {{ $t('CAMPAIGN_FLOW.CONFIG.BUTTON_TEXT') }}
              </woot-button>
              <woot-button class="btn-primary" variant="clear" @click.prevent="onClose">
                {{ $t('CAMPAIGN.ADD.CANCEL_BUTTON_TEXT') }}
              </woot-button>
            </div>

          </div>
        </form>
      </div>
    </woot-modal>
  </template>

  <script>
  import WootDateTimePicker from 'dashboard/components/ui/DateTimePicker.vue';
  import DelayInput from 'dashboard/components/widgets/DelayInput.vue';

  export default {
    components: {
      WootDateTimePicker,
      DelayInput,
    },
    props: {
      show: Boolean,
      listId: Number,
      onClose: Function,
      list: Array,
      triggerSelected: String,
      scheduledAtSelected: String,
      delaySelected: Number
    },
    data() {
      return {
        selectedListId: this.listId,
        selectedTriggerId: this.triggerSelected,
        delay: this.delaySelected,
        scheduledAt: this.scheduledAtSelected ? new Date(this.scheduledAtSelected) : null,
        triggers: [
          { id: 'after_creation', name: this.$t('CAMPAIGN_FLOW.CONFIG.FORM.TRIGGER.AFTER_CREATION') },
          { id: 'scheduling', name: this.$t('CAMPAIGN_FLOW.CONFIG.FORM.TRIGGER.SCHEDULING') },
        ],
      };
    },

    methods: {
      handleSubmit() {
        const selectedItem = this.list.find(item => item.id === this.selectedListId);

        if(this.selectedTriggerId === 'after_creation') {
          this.scheduledAt = null;
        }else {
          this.delay = null;
        }

        this.$emit("handle-submit", {
          list: selectedItem,
          triggerId: this.selectedTriggerId,
          delay: Number(this.delay),
          scheduledAt: this.scheduledAt,
        });
      },
      onChange(value) {
        this.scheduledAt = value;
      },
    }
  };
  </script>

  <style scoped>
  .modal-footer .button {
    margin-left: 0 !important;
  }
  </style>
